import { render } from "./Create.vue?vue&type=template&id=257423e0&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=257423e0&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257423e0"]])

export default __exports__